import React, { Component } from "react";
import { Button, Drawer, Popover, Space, Tooltip } from "antd";
import actions from "@redux/EditableTable/actions";
import { connect } from "react-redux";
import {
  FilterOutlined,
  ImportOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

import Detail from "@components/Table/Detail";
import _ from "lodash";
import appActions from "@redux/app/actions";
import board from "@assets/images/login.jpg";
import styled from "styled-components";
import facilityActions from "@redux/facility/actions";

class PageHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      value: [],
      filter_dates: [],
    };
  }

  handleImport = (e) => {
    this.props.onCloseImportModalRequest(false);
  };

  handleSelect = (e) => {
    this.props.handleSelect(e);
  };

  handleRefresh = (e) => {
    this.props.handleFresh();
  };

  handleOpenNew = (e) => {
    this.props.clearSelectedAddress();

    this.setState({
      isOpenNew: true,
    });
  };

  onClose = (e) => {
    this.setState({
      isOpenNew: false,
    });
  };

  handOnlineSave = async (key, row) => {
    let result = await this.props.createRecords(row);
    // console.log('result', result)
    if (!(result?.response?.status > 299)) {
      this.setState({
        isOpenNew: false,
      });
      this.props.handleFresh();
    }
  };

  formRefCallback = (formRef) => {
    // console.log('formRefCallback', formRef)
    this.props.getFormRef(formRef);
  };

  renderDrawer = () => {
    return (
      <>
        <Drawer
          width={window.innerWidth > 900 ? "90%" : "100%"}
          placement="right"
          closable={false}
          onClose={this.onClose}
          visible={this.state.isOpenNew}
          destroyOnClose={true}
          autoFocus={true}
        >
          <div>
            {this.state.isOpenNew ? (
              <Detail
                formFields={this.props.formFields}
                handOnlineSave={this.handOnlineSave}
                columnProps={this.props.columnProps}
                formClassName={this.props.formClassName}
                isNewRecords={true}
                onClose={this.onClose}
                formRefCallback={this.formRefCallback}
              />
            ) : (
              ""
            )}
          </div>
        </Drawer>
      </>
    );
  };

  handleOpenFilters = () => {
    this.setState({
      isOpenFilters: true,
    });
  };

  render() {
    const { endToolbarSlot } = this.props;
    return (
      <div
        className={
          (endToolbarSlot
            ? " table-page-header--root table-page-header--pro-toolbar-embedded -mx-3 items-center w-full"
            : " table-page-header--root -mx-3 items-center w-full")
        }
      >
        <div className=" lg:w-auto flex items-center justify-between px-3">
          <div>{/* {this.props.filterDescription} */}</div>
        </div>
        <div
          className={
            endToolbarSlot
              ? "table-page-header-toolbar-band max-w-full px-3 flex flex-nowrap items-center justify-start min-w-0"
              : "table-page-header-toolbar-band max-w-full px-3 flex flex-nowrap items-center justify-start min-w-0 mt-2"
          }
        >
          <div className="flex table-page-header-main-row table-page-header-main-row--split filter-item justify-between w-full min-w-0 items-center">
            <div className="table-page-header-filter-aux flex flex-nowrap items-center justify-start gap-3 min-w-0 flex-1">
              {typeof this.props.renderFilter !== "undefined"
                ? this.props.renderFilter()
                : ""}
            </div>

            {!this.props.isHideRefreshNews && (
              <div className={"flex items-center table-page-header-actions"}>
                <Space size={8} align="center" wrap={false} className="table-page-header-icon-group">
                {this.props.renderButtons ? this.props.renderButtons() : null}
                {this.props.hide_imports ? (
                  null
                ) : (
                  <Tooltip title="Import from file">
                    <Button
                      key="button0"
                      type="default"
                      shape="circle"
                      className="table-page-header-icon-btn"
                      icon={<ImportOutlined />}
                      onClick={this.handleImport}
                      aria-label="Import from file"
                    />
                  </Tooltip>
                )}

                <Tooltip title="Refresh list">
                  <Button
                    key="button1"
                    type="default"
                    shape="circle"
                    className="table-page-header-icon-btn reload-refresh-btn"
                    icon={<ReloadOutlined />}
                    onClick={this.handleRefresh}
                    aria-label="Refresh list"
                  />
                </Tooltip>

                {!this.props.hid_new ? (
                  <Tooltip
                    title={
                      this.props.new_text
                        ? this.props.new_text
                        : "Create new record"
                    }
                  >
                    <Button
                      key="button2"
                      type="default"
                      shape="circle"
                      className="table-page-header-icon-btn"
                      icon={<PlusOutlined />}
                      onClick={
                        typeof this.props.onNew === "function"
                          ? this.props.onNew
                          : this.handleOpenNew
                      }
                      aria-label={
                        this.props.new_text
                          ? this.props.new_text
                          : "Create new record"
                      }
                    />
                  </Tooltip>
                ) : (
                  null
                )}

                {this.props.toolBarRender && this.props.toolBarRender()}

                <Popover
                  content={
                    <div className="mt-3 text-center">
                      <div className="flex justify-between items-center border-b-2 py-2">
                        <div></div>
                        <button
                          className="text-blue-600 font-bold uppercase px-6 py-2 rounded"
                          onClick={this.props.resetFilters}
                        >
                          Reset
                        </button>
                      </div>
                      <div className="mt-2 px-7 py-3">
                        {/* Content will go here */}
                        {/* Example section */}
                        <div className="mb-4">
                          {typeof this.props.renderSearches !== "undefined"
                            ? this.props.renderSearches()
                            : ""}
                        </div>
                        {/* Add additional sections here */}
                      </div>
                    </div>
                  }
                  trigger="click"
                  placement="bottomRight"
                >
                  {typeof this.props.resetFilters !== "undefined" ? (
                    <Tooltip title="Filter and search">
                      <Button
                        key="button4"
                        type="default"
                        shape="circle"
                        icon={
                          <FilterOutlined
                            className={
                              this.props.filterHasValue
                                ? "text-orange-600"
                                : "text-gray-600"
                            }
                          />
                        }
                        className="table-page-header-icon-btn"
                        onClick={this.handleOpenFilters}
                        aria-label="Filter and search"
                      />
                    </Tooltip>
                  ) : (
                    <div className={"ml-5 px-3"} />
                  )}
                </Popover>
                {endToolbarSlot ? (
                  <span className="table-page-header-end-slot flex items-center">
                    {endToolbarSlot}
                  </span>
                ) : null}
                </Space>
              </div>
            )}
          </div>
        </div>
        {this.state.isOpenNew ? this.renderDrawer() : ""}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const role = _.get(state, "Auth.role", {});
  const Role = role && Object.keys(role)[0];
  return {
    Role: Role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCurrent: (e) => dispatch(appActions.changeCurrent(e)),
    OpenDrawer: (e, id) => dispatch(actions.OpenDrawer(e, id)),
    clearSelectedAddress: () => dispatch(facilityActions.SelectedAddress("")),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);
